 export default {
    createdBy: false,

    createdAt: false,

    updatedAt: false,

    id: {
      type: 'number',
      required: true,
      unique: true,
      columnName: 'clientid'
    },

    number: {
      type: 'string',
    },

    name: {
      type: 'string',
      allowNull: true,
      columnName: 'nombre'
    },

    rfc: {
      type: 'string',
      allowNull: true,
    },

    address: {
      type: 'string',
      allowNull: true,
      columnName: 'direccion'
    },
}





// WEBPACK FOOTER //
// ./src/models/Cliente.js